import {
    ComparisonSpecificationType,
    ComparisonTableItemType,
    ComparisonTableType,
    Nullable
} from "../../definitions/types";
import {ComparisonTableSpecificationModel} from "./comparisonTableSpecificationModel";
import {ComparisonTableItemModel} from "./comparisonTableItemModel";

export class ComparisonTableModel {
    private readonly _specifications: ComparisonTableSpecificationModel[];
    private readonly _items: ComparisonTableItemModel[];

    constructor(comparisonTableType?: Nullable<ComparisonTableType>) {
        this._specifications = comparisonTableType?.specifications
            .filter((specification): specification is ComparisonSpecificationType => specification !== null)
            .map((specification) => new ComparisonTableSpecificationModel(specification)) ?? [] as ComparisonTableSpecificationModel[];
        this._items = comparisonTableType?.items
            .filter((item): item is ComparisonTableItemType => item !== null)
            .map((item) => new ComparisonTableItemModel(item)) ?? [] as ComparisonTableItemModel[];
    }

    /**
     * @property specifications
     * @description The specifications of the comparison table.
     * @return {ComparisonTableSpecificationModel[]}
     */
    public get specifications(): ComparisonTableSpecificationModel[] {
        return this._specifications;
    }

    /**
     * @property hasSpecifications
     * @description Whether the comparison table has specifications.
     * @return {boolean}
     */
    public get hasSpecifications(): boolean {
        return this._specifications.length > 0;
    }

    /**
     * @property specificationCount
     * @description The number of specifications in the comparison table.
     * @return {number}
     */
    public get specificationCount(): number {
        return this._specifications.length;
    }

    /**
     * @property items
     * @description The items of the comparison table.
     * @return {ComparisonTableItemModel[]}
     */
    public get items(): ComparisonTableItemModel[] {
        return this._items;
    }

    /**
     * @property hasItems
     * @description Whether the comparison table has items.
     * @return {boolean}
     */
    public get hasItems(): boolean {
        return this._items.length > 0;
    }

    /**
     * @property itemCount
     * @description The number of items in the comparison table.
     * @return {number}
     */
    public get itemCount(): number {
        return this._items.length;
    }
}